"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DragBoxEvent = void 0;

var _Event = _interopRequireDefault(require("../events/Event.js"));

var _Pointer = _interopRequireDefault(require("./Pointer.js"));

var _Box = _interopRequireDefault(require("../render/Box.js"));

var _condition = require("../events/condition.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/DragBox
 */
// FIXME draw drag box


/**
 * A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */

/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~mouseActionButton}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default):void} [onBoxEnd] Code to execute just
 * before `boxend` is fired.
 */

/**
 * @enum {string}
 */
var DragBoxEventType = {
  /**
   * Triggered upon drag box start.
   * @event DragBoxEvent#boxstart
   * @api
   */
  BOXSTART: 'boxstart',

  /**
   * Triggered on drag when box is active.
   * @event DragBoxEvent#boxdrag
   * @api
   */
  BOXDRAG: 'boxdrag',

  /**
   * Triggered upon drag box end.
   * @event DragBoxEvent#boxend
   * @api
   */
  BOXEND: 'boxend',

  /**
   * Triggered upon drag box canceled.
   * @event DragBoxEvent#boxcancel
   * @api
   */
  BOXCANCEL: 'boxcancel'
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/DragBox~DragBox} instances are instances of
 * this type.
 */

var DragBoxEvent =
/** @class */
function (_super) {
  __extends(DragBoxEvent, _super);
  /**
   * @param {string} type The event type.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
   */


  function DragBoxEvent(type, coordinate, mapBrowserEvent) {
    var _this = _super.call(this, type) || this;
    /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */


    _this.coordinate = coordinate;
    /**
     * @const
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */

    _this.mapBrowserEvent = mapBrowserEvent;
    return _this;
  }

  return DragBoxEvent;
}(_Event["default"]);

exports.DragBoxEvent = DragBoxEvent;

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'boxcancel'|'boxdrag'|'boxend'|'boxstart', DragBoxEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'boxcancel'|'boxdrag'|'boxend', Return>} DragBoxOnSignature
 */

/**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom~DragRotateAndZoom}).
 *
 * @fires DragBoxEvent
 * @api
 */
var DragBox =
/** @class */
function (_super) {
  __extends(DragBox, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function DragBox(opt_options) {
    var _this = _super.call(this) || this;
    /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */


    _this.on;
    /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */

    _this.once;
    /***
     * @type {DragBoxOnSignature<void>}
     */

    _this.un;
    var options = opt_options ? opt_options : {};
    /**
     * @type {import("../render/Box.js").default}
     * @private
     */

    _this.box_ = new _Box["default"](options.className || 'ol-dragbox');
    /**
     * @type {number}
     * @private
     */

    _this.minArea_ = options.minArea !== undefined ? options.minArea : 64;

    if (options.onBoxEnd) {
      _this.onBoxEnd = options.onBoxEnd;
    }
    /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */


    _this.startPixel_ = null;
    /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */

    _this.condition_ = options.condition ? options.condition : _condition.mouseActionButton;
    /**
     * @private
     * @type {EndCondition}
     */

    _this.boxEndCondition_ = options.boxEndCondition ? options.boxEndCondition : _this.defaultBoxEndCondition;
    return _this;
  }
  /**
   * The default condition for determining whether the boxend event
   * should fire.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
   *     leading to the box end.
   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
   * @return {boolean} Whether or not the boxend condition should be fired.
   */


  DragBox.prototype.defaultBoxEndCondition = function (mapBrowserEvent, startPixel, endPixel) {
    var width = endPixel[0] - startPixel[0];
    var height = endPixel[1] - startPixel[1];
    return width * width + height * height >= this.minArea_;
  };
  /**
   * Returns geometry of last drawn box.
   * @return {import("../geom/Polygon.js").default} Geometry.
   * @api
   */


  DragBox.prototype.getGeometry = function () {
    return this.box_.getGeometry();
  };
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */


  DragBox.prototype.handleDragEvent = function (mapBrowserEvent) {
    this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
    this.dispatchEvent(new DragBoxEvent(DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
  };
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */


  DragBox.prototype.handleUpEvent = function (mapBrowserEvent) {
    this.box_.setMap(null);
    var completeBox = this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel);

    if (completeBox) {
      this.onBoxEnd(mapBrowserEvent);
    }

    this.dispatchEvent(new DragBoxEvent(completeBox ? DragBoxEventType.BOXEND : DragBoxEventType.BOXCANCEL, mapBrowserEvent.coordinate, mapBrowserEvent));
    return false;
  };
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   */


  DragBox.prototype.handleDownEvent = function (mapBrowserEvent) {
    if (this.condition_(mapBrowserEvent)) {
      this.startPixel_ = mapBrowserEvent.pixel;
      this.box_.setMap(mapBrowserEvent.map);
      this.box_.setPixels(this.startPixel_, this.startPixel_);
      this.dispatchEvent(new DragBoxEvent(DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
      return true;
    } else {
      return false;
    }
  };
  /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */


  DragBox.prototype.onBoxEnd = function (event) {};

  return DragBox;
}(_Pointer["default"]);

var _default = DragBox;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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